module.exports = __webpack_public_path__ + "img/info_icon.35342c73.svg";